import { useField } from 'formik';

import { useCallback } from 'react';
import {
    MultipleSelectCheckmarks,
    SharedMultipleSelectProps,
} from 'components/@shared/Select/MultipleSelectCheckmarks';

interface Props extends Omit<SharedMultipleSelectProps, 'ref' | 'onChange' | 'multiple' | 'value'> {
    name: string;
}

export const FormMultipleSelectCheckmarks = ({ rows, name, ...props }: Props) => {
    const [field, meta] = useField(name);

    return (
        <MultipleSelectCheckmarks
            {...props}
            {...field}
            rows={rows}
            error={meta.touched && Boolean(meta.error)}
            helperText={(meta.touched && meta.error) || props.helperText}
        />
    );
};
